import React, { useMemo, useState } from "react";
import Input from "../../../../../../components/Input/Input";
import Select from "../../../../../../components/Select/Select";
import Button from "../../../../../../components/Button/Button";
import "./GroupData.css";
//utils
import { formatDate } from "../../../../../../utils/utils";

const GroupData = ({ groupData, group, onDataChange, orgOptions = [] }) => {
  const [isEditing, setIsEditing] = useState(false);

  const fallbackOptions = [
    { value: "Church", label: "Church" },
    { value: "Business", label: "Business" },
    { value: "NGO", label: "NGO" },
    { value: "School", label: "School" },
    { value: "Community", label: "Community" },
    { value: "Other", label: "Other" },
  ];
  const options = orgOptions.length ? orgOptions : fallbackOptions;
  const rawOrg = groupData?.organization_type ?? group?.organization_type ?? "";

  const selectedOrgOpt = useMemo(() => {
    if (!rawOrg) return null;
    const asString = String(rawOrg).toLowerCase();
    return (
      options.find(
        (o) =>
          String(o.value).toLowerCase() === asString ||
          String(o.label).toLowerCase() === asString,
      ) || null
    );
  }, [rawOrg, options]);

  const ownerName = useMemo(() => {
    if (groupData?.owner?.name) return groupData.owner.name;

    const byRole = (groupData?.participants || []).find((p) => {
      const role = (p.role || "").toLowerCase();
      return role === "owner" || role === "administrator" || role === "admin";
    });
    if (byRole?.name) return byRole.name;

    return group?.owner || "";
  }, [groupData?.owner, groupData?.participants, group?.owner]);

  const orgLabel = selectedOrgOpt?.label ?? (rawOrg ? String(rawOrg) : "");

  const handleEdit = () => {
    if (isEditing) {
      // Aquí iría la lógica para guardar los cambios
      setIsEditing(false);
    } else {
      setIsEditing(true);
    }
  };
  const administrator = groupData.participants
    ? groupData.participants.filter((p) => p.role === "admin")
    : null;

  return (
    <div className="group-data-container">
      <div className="data-row">
        <div className="data-field">
          <h3>Name of group</h3>
          <Input
            type="text"
            value={groupData.name}
            onChange={(e) => onDataChange("name", e.target.value)}
            disabled={!isEditing}
          />
        </div>
        <div className="data-field">
          <h3>Description</h3>
          <Input
            type="text"
            value={groupData.description}
            onChange={(e) => onDataChange("description", e.target.value)}
            disabled={!isEditing}
          />
        </div>
        <div className="data-field">
          <h3>Type of organization</h3>
          {isEditing ? (
            <Select
              options={options}
              value={selectedOrgOpt}
              onChange={(opt) =>
                onDataChange("organization_type", opt?.value ?? "")
              }
              placeholder="Select organization type"
              isSearchable={true}
              isClearable={false}
            />
          ) : (
            <Input
              type="text"
              value={orgLabel} // <<-- ahora usa el label calculado
              disabled={true}
            />
          )}
        </div>
      </div>

      <div className="data-row">
        <div className="data-field">
          <h3>Group owner</h3>
          <Input type="text" value={ownerName} disabled={true} />
        </div>
        <div className="data-field">
          <h3>Administrators</h3>
          <Input
            type="text"
            value={administrator ? administrator.name : ""}
            onChange={(e) => onDataChange("administrators", e.target.value)}
            disabled={true}
          />
        </div>
        <div className="data-field">
          <h3>Date of creation</h3>
          <Input
            type="text"
            value={formatDate(groupData.created_at)}
            onChange={(e) => onDataChange("creationDate", e.target.value)}
            disabled={true}
          />
        </div>
      </div>

      <div className="data-row">
        <div className="data-field">
          <h3>City and country of creation</h3>
          <Input
            type="text"
            value={groupData.city}
            onChange={(e) => onDataChange("city", e.target.value)}
            disabled={true}
          />
        </div>
        <div className="data-field">
          <h3>Number of members</h3>
          <Input
            type="text"
            value={groupData.participants ? groupData.participants.length : 0}
            onChange={(e) => onDataChange("members", e.target.value)}
            disabled={true}
          />
        </div>
        <div className="data-field">
          <h3>Number of active services</h3>
          <Input
            type="text"
            value={
              groupData.participants
                ? groupData.participants.filter((p) => p.is_deleted === false)
                    .length
                : 0
            }
            onChange={(e) => onDataChange("activeServices", e.target.value)}
            disabled={true}
          />
        </div>
      </div>
      {isEditing && (
        <div className="data-row-bottom">
          <Button variant="primary" onClick={handleEdit} fullWidth>
            Edit
          </Button>
        </div>
      )}
      {isEditing && (
        <div className="row-edit-bottom">
          <Button variant="warning" onClick={handleEdit} fullWidth>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleEdit} fullWidth>
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

export default GroupData;
